/* AKS PRIVÉ — subtle fade-up on scroll. Respects reduced-motion.
   See AKS_OS/specs/plans/2026-06-28-website-phase0-plan.md (Task 5) */
document.addEventListener("DOMContentLoaded", function () {
  var els = document.querySelectorAll(".aks-fade");
  if (!els.length) return;
  if (!("IntersectionObserver" in window)) {
    els.forEach(function (e) { e.classList.add("is-in"); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-in");
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (e) { io.observe(e); });
});
